import { featuredStats } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto max-w-6xl px-4 pt-14 pb-4 md:px-6 md:pt-20">
        <div className="flex items-center gap-2.5">
          <span className="inline-flex h-6 items-center rounded-full bg-primary-100 px-3 text-xs font-medium text-primary-700">
            <i className="ri-fire-line mr-1.5 text-sm leading-none" />
            专题合集 · 持续进料
          </span>
          <span className="h-px flex-1 bg-background-200" />
          <span className="hidden text-xs text-foreground-600 sm:block">谁有瓜先点谁 · 收藏当目录</span>
        </div>

        <div className="mt-8 grid grid-cols-1 items-end gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <h1 className="font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl md:leading-tight">
              千万粉大网红的黑历史，
              <br className="hidden sm:block" />
              按<span className="text-primary-600">人物分批</span>归档给你看
            </h1>
            <p className="mt-6 max-w-2xl text-[15px] leading-7 text-foreground-700 md:text-base md:leading-8">
              专扒抖音头部主播老底与塌房旧账。人设崩塌、带货翻车、学历质疑、违约拆伙，按一个人一页往下铺，
              后续新料持续补进同一篇，不用翻来翻去。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#featured"
                className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                先看今日新料
                <i className="ri-arrow-down-line text-base" />
              </a>
              <a
                href="#dossier"
                className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-7 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer"
              >
                <i className="ri-file-list-3-line text-base" />
                打开人物目录
              </a>
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="flex flex-col gap-3 border-l border-background-200 pl-6 lg:pl-8">
              {featuredStats.map((s, i) => (
                <div key={s.label} className="flex items-baseline justify-between gap-4">
                  <span className={`font-heading text-2xl font-black ${i === 0 ? "text-accent-600" : "text-foreground-950"}`}>
                    {s.value}
                  </span>
                  <span className="whitespace-nowrap text-sm text-foreground-600">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}